<p-dialog modal="true" styleClass="atlas-dialog-m" position="top" [closable]="false" [(visible)]="show">
  <ng-template pTemplate="header" *ngIf="!loadingMember">
    <h4>
      {{
        committeeMember?.CommitteeMemberID
          ? ('committees.edit.committee-members.crud-dialog.edit-header' | translate | titlecase)
          : ('committees.edit.committee-members.crud-dialog.add-header' | translate | titlecase)
      }}
    </h4>
  </ng-template>
  <div class="mct-flex mct-row mct-justify-center mct-items-center">
    <wl-busy [show]="loadingMember"></wl-busy>
  </div>
  <form #crudForm="ngForm" [hidden]="loadingMember">
    <div class="dialog-body-container">
      <div [hidden]="showCrud">
        <p>{{ 'committees.edit.committee-members.crud-dialog.search-prompt' | translate | ucfirst }}</p>
        <wl-profile-search-and-select (profileSelected)="initWithProfile($event.ProfileId)"></wl-profile-search-and-select>
      </div>
      <div [hidden]="!showCrud">
        <wl-committee-member-edit [committeeId]="committeeId" [committeeMember]="committeeMember"></wl-committee-member-edit>
      </div>
    </div>
  </form>
  <ng-template pTemplate="footer">
    <div class="mct-flex mct-row mct-flex-lt-sm mct-col-lt-sm mct-justify-end mct-items-center mct-gap-10">
      <button type="button" class="atlas-btn atlas-btn-secondary" [disabled]="isSaving" (click)="cancel()">
        {{ 'common.cancel' | translate | uppercase }}
      </button>
      <button type="button" class="atlas-btn atlas-btn-primary" *ngIf="showCrud" [disabled]="!crudForm.valid" (click)="save()">
        <wl-busy [show]="isSaving"></wl-busy>
        <span [hidden]="isSaving">{{ 'common.save-and-close' | translate | uppercase }}</span>
      </button>
      <button
        class="atlas-btn atlas-btn-primary"
        *ngIf="showCrud && !committeeMember?.CommitteeMemberID"
        [disabled]="!crudForm.valid"
        (click)="saveAndAddAnother()"
      >
        <wl-busy [show]="isSaving"></wl-busy>
        <span [hidden]="isSaving">{{ 'common.save-and-add-another' | translate | uppercase }}</span>
      </button>
    </div>
  </ng-template>
</p-dialog>
